module.exports = __webpack_public_path__ + "static/media/Сборник тезисов. Часть 2.7bfc40cb.pdf";